import { Box, Skeleton, Typography } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

import { PLOT_PADDING_Y, Y_AXIS_WIDTH } from "~/feature/chart/constants";

import { ZONE_HEIGHT } from "./constants";

const VOLUME_COLOR = "#00b894";

export const Root = styled(Box)(({ theme }) => ({
  marginLeft: Y_AXIS_WIDTH,
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const ChartArea = styled(Box)({
  width: "100%",
  height: ZONE_HEIGHT,
  paddingTop: PLOT_PADDING_Y,
  overflow: "hidden",
});

export const Bars = styled(Box)({
  position: "relative",
  width: "100%",
  height: "100%",
});

export const Bar = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "$leftPercent" &&
    prop !== "$heightPercent" &&
    prop !== "$widthPercent",
})<{ $leftPercent: number; $heightPercent: number; $widthPercent: number }>(
  ({ $leftPercent, $heightPercent, $widthPercent }) => ({
    position: "absolute",
    bottom: 0,
    left: `${$leftPercent}%`,
    transform: "translateX(-50%)",
    width: `${$widthPercent}%`,
    height: `${$heightPercent}%`,
    backgroundColor: alpha(VOLUME_COLOR, 0.4),
    pointerEvents: "none",
  })
);

export const EmptyState = styled(Typography)(({ theme }) => ({
  height: ZONE_HEIGHT,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 12,
  color: theme.palette.text.disabled,
}));

export const SkeletonBars = styled(Box)({
  height: ZONE_HEIGHT,
  display: "flex",
  alignItems: "flex-end",
  gap: 2,
});

export const SkeletonBar = styled(Skeleton, {
  shouldForwardProp: (prop) => prop !== "$height",
})<{ $height: number }>(({ $height }) => ({
  flex: 1,
  height: `${$height}%`,
  transform: "none",
}));
